<template>
  <div class="star-logic-box">
    选择
    <el-select
      class="logic-select"
      style="width: 120px;margin:0 10px 10px;"
      v-model="currentLogic.start"
      placeholder="起始分值"
      @change="handleSelectStart"
    >
      <el-option
        v-for="(item, i) in options"
        :label="item + '分'"
        :value="item"
        :key="i"
        :disabled="currentLogic.end && item > currentLogic.end || disableOption.includes(item)"
      ></el-option>
    </el-select>到
    <el-select
      class="logic-select"
      style="width: 120px;"
      v-model="currentLogic.end"
      placeholder="结束分值"
      @change="handleSelectEnd"
    >
      <el-option
        v-for="(item, i) in options"
        :label="item + '分'"
        :value="item"
        :key="i"
        :disabled="item < currentLogic.start || disableOption.includes(item)"
      ></el-option>
    </el-select>跳转至
    <el-select
      class="logic-select"
      v-model="currentLogic.quetionId"
      placeholder="选择题目"
      @change="handleSelectQues"
    >
      <el-option
        v-for="(item, i) in allQues"
        :label="i+1 + '.' + removeLables(item.title)"
        :value="item.id"
        :key="i"
        :disabled="i <= index"
      ></el-option>
    </el-select>
    <a href="javascript:;" class="add-del" @click="handleAddOrDel('add')">
      <i class="el-icon-circle-plus-outline"></i>
    </a>
    <a href="javascript:;" class="add-del" @click="handleAddOrDel('sub')">
      <i class="el-icon-remove-outline"></i>
    </a>
  </div>
</template>
<script>
export default {
  name: "starLogic",
  data() {
    return {
      start: "",
      end: "",
      quetionId: "",
      isAble: false,
      isNew: true
    };
  },
  props: [
    "linkQues",
    "survey",
    "seqNum",
    "count",
    "logic",
    "starEntityList",
    "index",
    "allQues"
  ],
  computed: {
    currentLogic() {
      return this.logic;
    },
    options() {
      let _options = [];
      let linkQues = this.linkQues;
      for (
        var i = linkQues.starBeginNum;
        i < linkQues.starBeginNum + linkQues.starNum;
        i++
      ) {
        _options.push(i);
      }
      return _options;
    },
    disableOption() {
      let list = [];
      this.starEntityList.forEach((item, i) => {
        if (
          i != this.seqNum &&
          item.start != undefined &&
          item.end != undefined
        ) {
          for (let i = item.start; i <= item.end; i++) {
            list.push(i);
          }
        }
      });
      return list;
    }
  },
  methods: {
    handleSelectStart() {
      this.$emit("changeLogic", this.seqNum, {
        start: this.currentLogic.start,
        end: this.currentLogic.end,
        quetionId: this.currentLogic.quetionId
      });
    },
    handleSelectEnd() {
      this.$emit("changeLogic", this.seqNum, {
        start: this.currentLogic.start,
        end: this.currentLogic.end,
        quetionId: this.currentLogic.quetionId
      });
    },
    handleSelectQues() {
      this.$emit("changeLogic", this.seqNum, {
        start: this.currentLogic.start,
        end: this.currentLogic.end,
        quetionId: this.currentLogic.quetionId
      });
    },
    removeLables(html) {
      return html.replace(/<\/?.+?>/g, "");
    },
    handleAddOrDel(type) {
      this.$emit("addOrDel", type, this.seqNum);
    }
  }
};
</script>

<style lang="scss" >
.star-logic-box {
  overflow: hidden;
}
.logic-select {
  margin: 0 10px 10px;
}
.add-del {
  font-size: 26px;
  display: inline-block;
  position: relative;
  top: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/starLogic.vue